import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { handlePostRequest } from "../../services/PostTemplate";
import { handlePutRequest } from "../../services/PutTemplate";
import { useDispatch, useSelector } from "react-redux";
import { SetEditCompanyGroupFlagAction, SetCompanyGroupFormDataToNullAction } from "../../redux/actions/companyAction";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";

function AddEditGroupProfile() {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const dispatch = useDispatch();
    let history = useHistory();

    const editFlag__Store = useSelector((state) => state.companySlice?.companyGroupEditFlag);
    const formData__Store = useSelector((state) => state.companySlice?.companyGroupFormData);

    useEffect(() => {
        if (editFlag__Store) {
            fillCompanyGroupForm();
        }
    }, [editFlag__Store, formData__Store]); // eslint-disable-line

    const fillCompanyGroupForm = () => {
        formik.setFieldValue("groupCode", formData__Store?.groupCode?.toString());
        formik.setFieldValue("groupName", formData__Store?.groupName?.toString());
        formik.setFieldValue("relationship", formData__Store?.relationship?.toString());
        formik.setFieldValue("accountNo", formData__Store?.accountNo?.toString());
        formik.setFieldValue("discountable", formData__Store?.discountable?.toString());
        formik.setFieldValue("creditLimit", formData__Store?.creditLimit?.toString());
        formik.setFieldValue("outstandingAmount", formData__Store?.outstandingAmount?.toString());
        formik.setFieldValue("closed", formData__Store?.closed?.toString());
        formik.setFieldValue("closureReason", formData__Store?.closureReason?.toString());
        formik.setFieldValue("closedDate", formData__Store?.closedDate?.toString());
        formik.setFieldValue("closedTill", formData__Store?.closedTill?.toString());
        formik.setFieldValue("reopeningDate", formData__Store?.reopeningDate?.toString());
        formik.setFieldValue("cisNo", formData__Store?.cisNo?.toString());
        formik.setFieldValue("contactPerson", formData__Store?.contactPerson?.toString());
        formik.setFieldValue("address1", formData__Store?.address1?.toString());
        formik.setFieldValue("address2", formData__Store?.address2?.toString());
        formik.setFieldValue("address3", formData__Store?.address3?.toString());
        formik.setFieldValue("contactNo", formData__Store?.contactNo?.toString());
        formik.setFieldValue("faxNo", formData__Store?.faxNo?.toString());
        formik.setFieldValue("mobileNo", formData__Store?.mobileNo?.toString());
        formik.setFieldValue("email", formData__Store?.email?.toString());
        formik.setFieldValue("url", formData__Store?.url?.toString());
    };

    const cancelHandler = (e) => {
        e.preventDefault();
        formik.resetForm();
    };

    const validationSchema = Yup.object().shape({
        groupCode: Yup.string().required("This field is required.").max(20, "Maximum length 20 allowed").matches("^[0-9]*$", "Please enter numeric data"),
        groupName: Yup.string().max(200, "Maximum length 200 allowed").required("This field is required."),
        relationship: Yup.string().max(50, "Maximum length 50 allowed").required("This field is required."),
        accountNo: Yup.string()
            .required("This field is required.")
            .matches(/^[A-Za-z0-9 ]+$/, "Special Character are not allowed")
            .max(20, "Maximum length 20 allowed"),
        creditLimit: Yup.string().max(20, "Maximum length 20 allowed").matches("^[0-9]*$", "Please enter numeric data").nullable(),
        outstandingAmount: Yup.string().max(20, "Maximum length 20 allowed").matches("^[0-9]*$", "Please enter numeric data").nullable(),
        closureReason: Yup.string().max(100, "Maximum length 100 allowed").nullable(),
        cisNo: Yup.string().max(20, "Maximum length 20 allowed").matches("^[0-9]*$", "Please enter numeric data").nullable(),
        contactPerson: Yup.string().required("This field is required.").max(50, "Maximum length 50 allowed").nullable(),
        address1: Yup.string().max(200, "Maximum length 200 allowed").nullable(),
        address2: Yup.string().max(200, "Maximum length 200 allowed").nullable(),
        address3: Yup.string().max(200, "Maximum length 200 allowed").nullable(),
        contactNo: Yup.string().required("This field is required.").max(11, "Maximum length 11 allowed").matches("^[0-9]*$", "Please enter numeric data").nullable(),
        faxNo: Yup.string().max(20, "Maximum length 20 allowed").matches("^[0-9]*$", "Please enter numeric data").nullable(),
        mobileNo: Yup.string().required("This field is required.").min(11, "Minimum length 11 allowed").max(11, "Maximum length 11 allowed").matches("^[0-9]*$", "Please enter numeric data"),
        email: Yup.string().email("Invalid email address format").required("This field is required."),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            groupCode: "",
            groupName: "",
            relationship: "",
            accountNo: "",
            discountable: "N",
            creditLimit: "",
            outstandingAmount: "",
            closed: "N",
            closureReason: "",
            closedDate: "",
            closedTill: "",
            reopeningDate: "",
            cisNo: "",
            contactPerson: "",
            address1: "",
            address2: "",
            address3: "",
            contactNo: "",
            faxNo: "",
            mobileNo: "",
            email: "",
            url: "",
        },
        onSubmit: async (data) => {
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            if (editFlag__Store) {
                data["companyGroupId"] = formData__Store?.companyGroupId;
                const res = await handlePutRequest(data, "zbizgateway/nonFin/updateCompanyGroup");
                if (res?.status === 400) {
                    res?.data.forEach((element) => {
                        formik.setFieldError(element?.field, element?.message);
                    });
                } else {
                    dispatch(SetEditCompanyGroupFlagAction(false));
                    dispatch(SetCompanyGroupFormDataToNullAction());
                    formik.resetForm();
                }
            } else {
                const res = await handlePostRequest(data, "zbizgateway/nonFin/saveCompanyGroup");
                if (res?.status === 400) {
                    res?.data.forEach((element) => {
                        formik.setFieldError(element?.field, element?.message);
                    });
                } else formik.resetForm();
            }
            setloading(false);
            setloadingIcon("pi pi-save");
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <div className="card Card__Round">
            <div className="Form__Header">
                <h1>Group Profile Setup</h1>
            </div>
            <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                <div className="p-fluid p-formgrid p-grid">
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="groupCode" className={classNames({ "p-error": isFormFieldValid("groupCode") }, "Label__Text")}>
                                Group Code<span className="Label__Required">*</span>
                            </label>
                            <InputText id="groupCode" placeholder="#000000" name="groupCode" value={formik.values.groupCode?.toString()?.trim()} onChange={formik.handleChange} autoFocus className={classNames({ "p-invalid": isFormFieldValid("groupCode") }, "Input__Round")} />

                            {getFormErrorMessage("groupCode")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="groupName" className={classNames({ "p-error": isFormFieldValid("groupName") }, "Label__Text")}>
                                Group Name<span className="Label__Required">*</span>
                            </label>
                            <InputText id="groupName" placeholder="#000000" name="groupName" value={formik.values.groupName?.replace(/\s\s+/g, " ")} onChange={formik.handleChange} autoFocus className={classNames({ "p-invalid": isFormFieldValid("groupName") }, "Input__Round")} />

                            {getFormErrorMessage("groupName")}
                        </div>
                    </div>

                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="relationship" className={classNames({ "p-error": isFormFieldValid("relationship") }, "Label__Text")}>
                                Relationship<span className="Label__Required">*</span>
                            </label>
                            <InputText id="relationship" placeholder="#000000" name="relationship" value={formik.values.relationship?.replace(/\s\s+/g, " ")} onChange={formik.handleChange} autoFocus className={classNames({ "p-invalid": isFormFieldValid("relationship") }, "Input__Round")} />

                            {getFormErrorMessage("relationship")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="accountNo" className={classNames({ "p-error": isFormFieldValid("accountNo") }, "Label__Text")}>
                                Account Number<span className="Label__Required">*</span>
                            </label>
                            <InputText id="accountNo" placeholder="#000000" name="accountNo" value={formik.values.accountNo?.toString()?.trim()} onChange={formik.handleChange} autoFocus className={classNames({ "p-invalid": isFormFieldValid("accountNo") }, "Input__Round")} />

                            {getFormErrorMessage("accountNo")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <label htmlFor="firstname6" className="Label__Text">
                            Discountable
                        </label>
                        <div className="Radio__Btn">
                            <div className="p-field-radiobutton">
                                <RadioButton inputId="discountable" name="discountable" value={"N"} onChange={formik.handleChange} checked={formik.values.discountable === "N"} />
                                <label htmlFor="discountable">No</label>
                            </div>
                            <div className="p-field-radiobutton">
                                <RadioButton inputId="discountable" name="discountable" value={"Y"} onChange={formik.handleChange} checked={formik.values.discountable === "Y"} />
                                <label htmlFor="discountable">Yes</label>
                            </div>
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="creditLimit" className={classNames({ "p-error": isFormFieldValid("creditLimit") }, "Label__Text")}>
                                Credit Limit
                            </label>
                            <InputText id="creditLimit" placeholder="#xxxxxx" name="creditLimit" value={formik.values.creditLimit?.toString()?.trim()} onChange={formik.handleChange} autoFocus className={classNames({ "p-invalid": isFormFieldValid("creditLimit") }, "Input__Round")} />

                            {getFormErrorMessage("creditLimit")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="outstandingAmount" className={classNames({ "p-error": isFormFieldValid("outstandingAmount") }, "Label__Text")}>
                                Outstanding
                            </label>
                            <InputText
                                id="outstandingAmount"
                                placeholder="#xxxxxx"
                                name="outstandingAmount"
                                value={formik.values.outstandingAmount?.toString()?.trim()}
                                onChange={formik.handleChange}
                                autoFocus
                                className={classNames({ "p-invalid": isFormFieldValid("outstandingAmount") }, "Input__Round")}
                            />

                            {getFormErrorMessage("outstandingAmount")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <label htmlFor="firstname6" className="Label__Text">
                            Closed
                        </label>
                        <div className="Radio__Btn">
                            <div className="p-field-radiobutton">
                                <RadioButton inputId="closed" name="closed" value={"N"} onChange={formik.handleChange} checked={formik.values.closed === "N"} />
                                <label htmlFor="city1">No</label>
                            </div>
                            <div className="p-field-radiobutton">
                                <RadioButton inputId="closed" name="closed" value={"Y"} onChange={formik.handleChange} checked={formik.values.closed === "Y"} />
                                <label htmlFor="city2">Yes</label>
                            </div>
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="closureReason" className={classNames({ "p-error": isFormFieldValid("closureReason") }, "Label__Text")}>
                                Closure Reason
                            </label>
                            <InputText id="closureReason" placeholder="#xxxxxx" name="closureReason" value={formik.values.closureReason?.replace(/\s\s+/g, " ")} onChange={formik.handleChange} autoFocus className={classNames({ "p-invalid": isFormFieldValid("closureReason") }, "Input__Round")} />

                            {getFormErrorMessage("closureReason")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <label htmlFor="closedDate" className="Label__Text">
                            Closed Date
                        </label>
                        <InputText type="date" id="closedDate" name="closedDate" value={formik.values.closedDate} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("closedDate") }, "Input__Round")} />
                        {getFormErrorMessage("closedDate")}
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <label htmlFor="closedTill" className="Label__Text">
                            Close Till
                        </label>
                        <InputText type="date" id="closedTill" name="closedTill" value={formik.values.closedTill} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("closedTill") }, "Input__Round")} />
                        {getFormErrorMessage("closedTill")}
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <label htmlFor="reopeningDate" className="Label__Text">
                            Reopening Date
                        </label>
                        <InputText type="date" id="reopeningDate" name="reopeningDate" value={formik.values.reopeningDate} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("reopeningDate") }, "Input__Round")} />
                        {getFormErrorMessage("reopeningDate")}
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="cisNo" className={classNames({ "p-error": isFormFieldValid("cisNo") }, "Label__Text")}>
                                CIS NO.
                            </label>
                            <InputText id="cisNo" placeholder="#xxxxxx" name="cisNo" value={formik.values.cisNo?.toString()?.trim()} onChange={formik.handleChange} autoFocus className={classNames({ "p-invalid": isFormFieldValid("cisNo") }, "Input__Round")} />

                            {getFormErrorMessage("cisNo")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="contactPerson" className={classNames({ "p-error": isFormFieldValid("contactPerson") }, "Label__Text")}>
                                Contact Person<span className="Label__Required">*</span>
                            </label>
                            <InputText
                                id="contactPerson"
                                type="text"
                                placeholder="Enter person"
                                name="contactPerson"
                                value={formik.values.contactPerson?.replace(/\s\s+/g, " ")}
                                onChange={formik.handleChange}
                                autoFocus
                                className={classNames({ "p-invalid": isFormFieldValid("contactPerson") }, "Input__Round")}
                            />

                            {getFormErrorMessage("contactPerson")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="address1" className={classNames({ "p-error": isFormFieldValid("address1") }, "Label__Text")}>
                                Address 1
                            </label>
                            <InputText id="address1" placeholder="Enter address" name="address1" value={formik.values.address1?.replace(/\s\s+/g, " ")} onChange={formik.handleChange} autoFocus className={classNames({ "p-invalid": isFormFieldValid("address1") }, "Input__Round")} />

                            {getFormErrorMessage("address1")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="address2" className={classNames({ "p-error": isFormFieldValid("address2") }, "Label__Text")}>
                                Address 2
                            </label>
                            <InputText id="address2" placeholder="Enter address" name="address2" value={formik.values.address2?.replace(/\s\s+/g, " ")} onChange={formik.handleChange} autoFocus className={classNames({ "p-invalid": isFormFieldValid("address2") }, "Input__Round")} />

                            {getFormErrorMessage("address2")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="address3" className={classNames({ "p-error": isFormFieldValid("address3") }, "Label__Text")}>
                                Address 3
                            </label>
                            <InputText id="address3" placeholder="Enter address" name="address3" value={formik.values.address3?.replace(/\s\s+/g, " ")} onChange={formik.handleChange} autoFocus className={classNames({ "p-invalid": isFormFieldValid("address3") }, "Input__Round")} />

                            {getFormErrorMessage("address3")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="contactNo" className={classNames({ "p-error": isFormFieldValid("contactNo") }, "Label__Text")}>
                                Contact Number<span className="Label__Required">*</span>
                            </label>
                            <InputText id="contactNo" type="text" placeholder="Enter number" name="contactNo" value={formik.values.contactNo?.toString()?.trim()} onChange={formik.handleChange} autoFocus className={classNames({ "p-invalid": isFormFieldValid("contactNo") }, "Input__Round")} />

                            {getFormErrorMessage("contactNo")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="faxNo" className={classNames({ "p-error": isFormFieldValid("faxNo") }, "Label__Text")}>
                                Fax No.
                            </label>
                            <InputText id="faxNo" type="text" placeholder="#xxxxxx" name="faxNo" value={formik.values.faxNo?.toString()?.trim()} onChange={formik.handleChange} autoFocus className={classNames({ "p-invalid": isFormFieldValid("faxNo") }, "Input__Round")} />

                            {getFormErrorMessage("faxNo")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="mobileNo" className={classNames({ "p-error": isFormFieldValid("mobileNo") }, "Label__Text")}>
                                Mobile No.<span className="Label__Required">*</span>
                            </label>
                            <InputText id="mobileNo" type="text" placeholder="Enter number" name="mobileNo" value={formik.values.mobileNo?.toString()?.trim()} onChange={formik.handleChange} autoFocus className={classNames({ "p-invalid": isFormFieldValid("mobileNo") }, "Input__Round")} />

                            {getFormErrorMessage("mobileNo")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="email" className={classNames({ "p-error": isFormFieldValid("email") }, "Label__Text")}>
                                Email<span className="Label__Required">*</span>
                            </label>
                            <InputText id="email" type="email" placeholder="Enter email" name="email" value={formik.values.email} onChange={formik.handleChange} autoFocus className={classNames({ "p-invalid": isFormFieldValid("email") }, "Input__Round")} />

                            {getFormErrorMessage("email")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="url" className={classNames({ "p-error": isFormFieldValid("url") }, "Label__Text")}>
                                URL
                            </label>
                            <InputText id="url" placeholder="#xxxxxxx" name="url" value={formik.values.url?.toString()?.trim()} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("url") }, "Input__Round")} />

                            {getFormErrorMessage("url")}
                        </div>
                    </div>
                </div>
                <div className="Down__Btn">
                    <Button label="Cancel" className="Btn__Transparent" onClick={(e) => cancelHandler(e)} />
                    <Button disabled={loading} icon={loadingIcon || ""} iconPos="right" label={editFlag__Store ? "Edit" : "Add"} className="Btn__Dark" />
                </div>
            </form>
        </div>
    );
}

export default AddEditGroupProfile;
